import React from 'react'
import { PaymentSourceContextType, usePaymentSource } from './PaymentSourceContext'

export function withPaymentSource<P extends PaymentSourceContextType>(WrappedComponent: React.ComponentType<P>) {
  console.log('withPaymentSource: ', WrappedComponent)
  return (props: Omit<P, keyof PaymentSourceContextType>) => {
    const { paymentSource, setPaymentSource } = usePaymentSource()

    return <WrappedComponent {...props as P} paymentSource={paymentSource} setPaymentSource={setPaymentSource} />
  }
}



// WEBPACK FOOTER //
// ./src/components/riders/riderdetails/payments/PaymentSourceHOC.tsx